<script>
import OrderCard from "@/components/Order/Components/Card/Index";

export default {
  components: {
    OrderCard
  },

  props: {
    ordersProvisioning: {
      type: Array,
      required: true
    }
  },

  computed: {
    totalOrders: function() {
      return this.ordersProvisioning.length;
    }
  }
};
</script>

<template>
  <transition name="down" mode="out-in">
    <div class="orders" v-if="totalOrders">
      <div class="header">
        Limpezas em andamento ({{ totalOrders }})
      </div>

      <div class="body">
        <OrderCard
          v-for="order in ordersProvisioning"
          :key="order.id"
          :payable="order"
        />
      </div>
    </div>
  </transition>
</template>

<style scoped>
.orders {
  padding: 12px;
  background-color: #fff;
  border-radius: 2px;
  transition-delay: 500ms;
}

.header {
  margin-bottom: 8px;
  font-weight: 400;
  color: #424242;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/components/Payables/ProvisioningPayables.vue